import { StateStorage } from 'zustand/middleware'
import { createStore } from '..'

export interface EvmSession {
  host: string
  chainId: string
  address?: string
  peerMeta: {
    name?: string
    url: string
    icon?: string
  }
  createdAt: number
}

export interface EvmSessionsStore {
  sessions: Record<string, EvmSession>
  addSession: (session: EvmSession) => void
  setChain: (host: string, chainId: string) => void
  setAddress: (host: string, address: string | undefined) => void
  removeSession: (host: string) => void
  getSession: (host: string) => EvmSession | undefined
  getAllSessions: () => EvmSession[]
  clearAllSessions: () => void
}

export const createEvmSessionsStore = (storage: StateStorage) =>
  createStore<EvmSessionsStore>(
    storage,
    (set, get) => ({
      sessions: {},
      addSession: (session) => {
        set({
          sessions: {
            ...get().sessions,
            [session.host]: session,
          },
        })
      },
      setChain: (host, chainId) => {
        const session = get().sessions[host]
        if (!session) return
        set({
          sessions: {
            ...get().sessions,
            [host]: { ...session, chainId },
          },
        })
      },
      setAddress: (host, address) => {
        const session = get().sessions[host]
        if (!session) return
        set({
          sessions: {
            ...get().sessions,
            [host]: { ...session, address },
          },
        })
      },
      removeSession: (host) => {
        const { [host]: _, ...rest } = get().sessions
        set({ sessions: rest })
      },
      getSession: (host) => get().sessions[host],
      getAllSessions: () => Object.values(get().sessions),
      clearAllSessions: () => set({ sessions: {} }),
    }),
    {
      persist: {
        name: 'evmSessions',
        version: 0,
      },
    }
  )
